import {React, Component} from 'react'
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";


import FormInput from "../../components/FormInput/FormInput"
import Header from '../../components/Header/Header'
import Tile from '../../components/Tile/Tile';
import notFoundGif from '../../assets/404.gif'
import './Search.css';


class Search extends Component {
  constructor(props){
    super(props)
    this.state = {
      query_results: [],
      query: "",
      grouped_labels: [ 
        {
          color: "cornflowerblue",
          labels: ["shape", "heart", "circle", "square", "triangle"]

        },        
        {
          color: "plum",
          labels: ["animal", "ape", "bear", "bird", "bug", "bunny", "bull", "cat",  "crab", "dog", "flower", "fox", "frog", "jellyfish", "mammal", "mouse", "plant", "panda", "reptile"]

        },
        {
          color: "lightgrey",
          labels:['creature', "cyclops", "alien", "android", "blob", "ghost", "human", "ogre", "robot", "slime", "skeleton", "transformer",  "zombie" ]
        },
  
        {
          color: "burlywood",
          labels: ["abstract", "dark",  "holes", "minimal",  "light", "lowContrast", "highContrast", "xSymmetrical", "twoTone", "upsidedown"]

        },
        {
          color: "mediumpurple",
          labels: ["face", "eyes", "ears", "horns", "mouth", "nose"]

        },
        {
          color: "darkseagreen",
          labels: ["object", "comet", "food", "hat",  "helmet", "mask", "skull", "spaceship", "invader", "tool"]

        },
        {
          color: "lightcoral",
          labels: ["emoji", "smiley", "idk"]

        },
      ],
      selected_labels: {upsidedown: false, horns: false, hat: false, food: false, transformer: false, comet: false, spaceship:false, triangle:false, bird: false, smiley:false, zombie: false, cyclops: false, ogre: false, face: false, eyes: false, mouth: false, ears: false, nose: false, bug: false, blob: false, slime: false, fox: false, plant: false, flower: false, bunny: false, android: false, jellyfish: false, mammal: false, reptile: false, skeleton: false,shape: false, heart: false, circle: false, square: false, animal: false, alien: false, ape: false, bear: false, bull: false, cat: false, creature: false,  crab: false, dog: false, frog: false, ghost: false, human: false, mouse: false, panda: false, robot: false, abstract: false, dark: false,  holes: false, minimal: false,  light: false, lowContrast: false, highContrast: false, xSymmetrical: false, twoTone: false, object: false,  helmet: false, mask: false, skull: false,  invader: false, tool: false,emoji: false, idk: false},

    }

    this.formInputHandler = this.formInputHandler.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    
  }
  

  formInputHandler(label){ //handle form input. the buttons are done with some hackey state variable. Should use useRef() in the future
   
    let newSelectedLabels = {upsidedown: false, horns: false, hat: false, food: false, transformer: false, comet: false, spaceship:false, triangle:false, bird: false, smiley:false, zombie: false, cyclops: false, ogre: false, face: false, eyes: false, mouth: false, ears: false, nose: false, bug: false, blob: false, slime: false, fox: false, plant: false, flower: false, bunny: false, android: false, jellyfish: false, mammal: false, reptile: false, skeleton: false,shape: false, heart: false, circle: false, square: false, animal: false, alien: false, ape: false, bear: false, bull: false, cat: false, creature: false,  crab: false, dog: false, frog: false, ghost: false, human: false, mouse: false, panda: false, robot: false, abstract: false, dark: false,  holes: false, minimal: false,  light: false, lowContrast: false, highContrast: false, xSymmetrical: false, twoTone: false, object: false,  helmet: false, mask: false, skull: false,  invader: false, tool: false,emoji: false, idk: false}
    newSelectedLabels[label] = !this.state.selected_labels[label]
    this.setState({selected_labels: newSelectedLabels, query: label}) //use destructuring here lol
    

    if(label){
      const postData = {
        "query": label,
        "operator": ">",
        "value": 0
      }
  
      fetch("https://jittery-river-production.up.railway.app/query", {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          body: JSON.stringify(postData) // body data type must match "Content-Type" header
      })
      .then(response=>response.json())
      .then(data=>this.setState({query_results: data}))  
    }else{
      this.setState({query_results: []})
    }


  }


  handleSearch(){
    

    //data formatted this way because backend schema expectations
    if(this.state.query){
      const postData = {
        "query": this.state.query,
        "operator": ">",
        "value": 0
      }
  
      fetch("https://jittery-river-production.up.railway.app/query", {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          body: JSON.stringify(postData) // body data type must match "Content-Type" header
      })
      .then(response=>response.json())
      .then(data=>this.setState({query_results: data}))  
    }else{
      this.setState({query_results: []})
    }

  }
  

  render(){
   
    return (
      <div className="Search">
        
  
              <Header/>
              <div style={{fontSize:"65px", margin:"20px 0px 20px 0px", fontWeight:"900", letterSpacing:"3px"}}>Search</div>

              <div>
                {/* <input className="query" type="text" placeholder="search via label" onChange={(e)=>{this.setState({query:e.target.value})}}/>
                <button className="submit" onClick={()=>{this.handleSearch()}}>Search</button> */}


                <div className="labels">
                    <div style={{width:"60%"}}>
                      {this.state.grouped_labels.map(elem=>{
                            var label_color = elem.color
                            return(
                              <span>
                              {elem.labels.map(elem=><FormInput formHandler={this.formInputHandler} color={label_color} data={elem} selected={this.state.selected_labels[elem]} style={{fontSize:"18px", padding: "1px 2px"}}/>)}
                              </span>
                            )
                          })
                        }
                    </div>
                      
                        
                  </div>
              </div>
              
             
              <div>
                { this.state.query_results.length ? <div></div> : <img style={{borderRadius:"5px", width:"35%", maxWidth:"350px", marginTop:"50px"}} src={notFoundGif} alt="Feeling Blue"/> }
              </div>

              
              
              
              <div className="results">

                {this.state.query_results.sort((a,b)=>{return(b[this.state.query] - a[this.state.query])}).map(element=>{
                  return(
                    <Tile key={element["id"]} element={element}/>
                  )
                })}

              </div>
        </div>
    
    
    );
  
  }
}

export default Search;
